import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { LoaderService } from "src/app/services/interceptor/loader.service";
import { MainService } from "src/app/services/main/main.service";
// import { MatDialog } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from "src/app/services/auth/auth.service";
import { SimpleDialogComponent } from "src/app/shared/simple-dialog/simple-dialog.component";
import { getUserProfile, getUserProfiles, setUserProfiles } from 'src/app/core/session';
@Component({
    selector: 'app-instant-payout',
    templateUrl: './instant-payout.component.html',
    styleUrls: ['./instant-payout.component.scss']
})

export class InstantPayoutComponent implements OnInit {

    payoutAmount: number;
    remainingBalance: number = 0;
    payoutFee: number = 0;
    showSummary :boolean = false;
    isBankSelected = false;
    isCardSelected = false;
    terms: boolean = false;
    instantCard: any = {};
    profileData: any = getUserProfiles();
    instant_payout_config: any = getUserProfile().instant_payout_config;
    doctor_id: number;
    contentLoaded: boolean = false;
    ind_id: any = 0;
    errorType: number = 0;

    constructor(
        public dialog: MatDialog,
        public mainService: MainService,
        public loaderService: LoaderService,
        private router: Router,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.loaderService.show();
        this.getAllInstantCards();
        
        const video = document.createElement('video');
        video.src = 'assets/img/video/payout_illustration.mp4';

        const bank_svg = new Image();
        bank_svg.src = 'assets/img/png/instant_pay_bank.png';

        const card_svg = new Image();
        card_svg.src = 'assets/img/png/card-billing.png';

        // Promise.all([
        //     bank_svg.decode(),
        //     card_svg.decode(),
        //     new Promise<void>((resolve) => {
        //         video.oncanplaythrough = () => resolve();
        //         video.onerror = () => resolve();
        //     })
        // ]).finally(() => {
        //     this.contentLoaded = true;
        //     this.loaderService.hide();
        // });
        this.contentLoaded = true;

        this.ind_id = this.profileData[0].ind_id;
        // this.instant_payout_config = this.profileData[0].instant_payout_config;
        this.doctor_id = this.profileData[0].doctor_id;
        if(this.instant_payout_config && this.instant_payout_config.card_number){
            this.instantCard.card_id = this.instant_payout_config.card_id;
            this.instantCard.brand = this.instant_payout_config.card_name;
            this.instantCard.last4 =  this.instant_payout_config.card_number;
        }
        if(this.profileData[0].instantCard){
            this.instantCard = this.profileData[0].instantCard;
            // console.log(this.profileData[0].instantCard);
        }
        this.authService.userProfileData$.subscribe((data)=>{
            if(data){
                this.instant_payout_config = data[0].instant_payout_config;
            }
        });
    }

    goToDashboard() {
        this.loaderService.show();
        const btn = document.getElementById('dashboard_btn'); 
        if(btn){
            btn.classList.add("dissolve-animate");
        }
        setTimeout(() => {
            this.router.navigate(['app/dashboard']); 
            this.loaderService.hide();
        }, 800);
    }

    blockInvalidKeys(event: KeyboardEvent): void {
        const invalidKeys = ['-', 'e', '+'];
        if (invalidKeys.includes(event.key)) {
          event.preventDefault();
        }
    }

    validateAmount(event: any): void {
        const input = event.target as HTMLInputElement;
        let enteredValue = event.target.value;
        const maxLength = 8;
        let regex = new RegExp('^\\d*\\.?\\d{0,' + 2 + '}$');
        if (!regex.test(enteredValue.toString())) {
            const truncatedValue = Math.floor(enteredValue * 100) / 100;
            input.value = truncatedValue.toFixed(2); 
            this.payoutAmount = truncatedValue;
        }
        if(enteredValue.length > maxLength){
            input.value = enteredValue.slice(0, maxLength);
            this.payoutAmount = parseFloat(input.value);
        }
        this.errorType = 0;
        if(this.payoutAmount < 1){
            this.errorType = 1;
        } else {
            if(this.instant_payout_config.daily_single_payout_amount < this.instant_payout_config.total_payout){
                if(this.payoutAmount > this.instant_payout_config.daily_single_payout_amount){
                    this.errorType = 2;
                }
            } else {
                if(this.payoutAmount > this.instant_payout_config.total_payout){
                    this.errorType = 3;
                }
            }
        }
        this.showSummary = this.payoutAmount > 0 ? true : false;

        this.remainingBalance = (this.instant_payout_config.total_payout - this.payoutAmount);
        // this.payoutFee = (this.payoutAmount * this.instant_payout_config.payout_fee_percentage) / 100;
        this.payoutFee = parseFloat(((this.payoutAmount * this.instant_payout_config.payout_fee_percentage) / 100).toFixed(2));
    }

    selectBank() {
        this.isBankSelected = true;
        this.isCardSelected = false;
    }
    
    selectCard() {
        this.isCardSelected = true;
        this.isBankSelected = false;
    }

    addInstantPayoutCard(){      
        let addInstantPayCard;
        this.loaderService.show();
        addInstantPayCard = this.dialog.open(SimpleDialogComponent, {
            width: '520px',
            height: '420px',
            panelClass: 'simpleDialog',
            data: {
                type: 946,
                actio: 'Add',
                title: 'Add Card',
                send_data: {
                    doctor_id: this.doctor_id
                }
            }
        });
        setTimeout(() => {
            this.loaderService.hide();
        }, 1000)
        addInstantPayCard.afterClosed().subscribe(() => {
            this.getAllInstantCards();
        });
    }
    
    getAllInstantCards() {
        this.loaderService.show();
        let data = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.doctor_id
        }
        this.mainService.api(data, 'instant_card_listing', false)
        .subscribe((data: any) => {
            if (!data.is_error && data.result.length > 0) {
                this.instantCard = data.result[0];
                this.profileData[0].instantCard = this.instantCard;
                setUserProfiles(this.profileData);
            }
            this.loaderService.hide();
        }, (error: any) => {
            console.log(error);
        });
    }

    getCardBrandImage(card){
        if (card) { 
            let brand = (card.brand || card.card.brand).toLowerCase();
            let allowedBrands = ['mastercard', 'discover', 'jcb', 'visa', 'american express', "unionpay", 'diners', 'amex'];
            if (brand === 'american express' || brand == 'amex') {
              return `assets/img/svg/card-type/American Express.svg`;
            }
            if (brand === 'mastercard') {
              return `assets/img/svg/card-type/MasterCard.svg`;
            }
            if (brand === 'unionpay') {
              return `assets/img/svg/card-type/UnionPay.svg`;
            }
            if (brand === 'diners') {
              return `assets/img/svg/card-type/Diners Club.svg`;
            }
            if (brand === 'jcb') {
              return `assets/img/svg/card-type/JCB.svg`;
            }
            return brand && allowedBrands.includes(brand)
              ? `assets/img/svg/card-type/${this.capitalizeFirstLetter(brand)}.svg`
              : 'assets/img/svg/card-type/no_card.svg';
        }
    }

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    makeInstantPayout() {
        let payout_limit = this.instant_payout_config.daily_remaining_payouts;
        if(payout_limit > 0){
            let data = {
                access_token: localStorage.getItem('token'),
                payment_method: this.isBankSelected ? 1 : 2, //1: bank, 2: card
                source_id: this.isBankSelected ? this.instant_payout_config.bank_id : this.isCardSelected ? this.instantCard.card_id : null,
                doctor_id: this.doctor_id,
                instant_payout_amount: this.payoutAmount,
                instant_payout_fee: this.payoutFee,
            };
            this.mainService.api(data, 'pay_instant_payout', false)
            .subscribe((response: any) =>{
                if(response.is_error == 0) {
                    const result = response.result;
                    this.profileData[0].instant_payout_config.in_transit_payout = result.in_transit_payout;
                    this.profileData[0].instant_payout_config.total_payout = result.total_payout;
                    this.profileData[0].instant_payout_config.instant_payout_amount = result.instant_payout_amount;
                    this.profileData[0].instant_payout_config.daily_remaining_payouts = result.daily_remaining_payouts;
                    this.profileData[0].instant_payout_config.daily_single_payout_amount = result.daily_single_payout_amount;
                    setUserProfiles(this.profileData);
                    this.authService.userProfileData$.next(this.profileData);
                    this.dialog.open(SimpleDialogComponent, {
                        width: '507px',
                        panelClass: 'simpleDialog',
                        data: { 
                          type: 947,
                          send_data: {
                            payoutAmount: this.payoutAmount,
                            payout_fee_percentage: this.instant_payout_config.payout_fee_percentage,
                            last4: this.isCardSelected ? this.instantCard.last4 : this.isBankSelected ? this.instant_payout_config.bank_account_number : '',
                          }
                        }
                      });
                      this.clearData();
                } else{
                    this.mainService.customPopups(response.err,1);
                }
            }, (error: any) => {
                console.log(error); 
            });
        } 
        else {
            this.mainService.customPopups("Daily Payout limit exceeded",1);
        }
    } 
    clearData(){
        // this.payoutAmount = null;
        const input = document.getElementById('payoutAmount') as HTMLInputElement;
        input.value = '';
        this.isBankSelected = false;
        this.isCardSelected = false;
        this.terms = false;
        this.showSummary = false;
        console.log(this.instant_payout_config.total_payout);
        console.log(this.payoutAmount);
    }     

}
